export const TAB_KEYS = {
  PICKUP: 'Pickup',
  DELIVERY: 'Delivery',
};

export const INITIAL_TRAILER_DETAILS = {
  selTrailer: null,
  txtUserName: null,
  txtRSCM: null,
  txtSCS: null,
  selPartner: null,
  PartnerLocation: null,
  UnitSize: null,
  txtinvJusti: null,
  Commodity: null,
  productType: null,
  selYardValue: null,
  entryDate: null,
  emptyDate: null,
  PickupRentalCompany: null,
  unitEmpty: false,

  orgLocations: [
    {
      orgShipLocation: null,
      orgSpotDate: null,
      orgETD: null,
      orgSoftWeight: 0,
      orgSoftOks: 0,
      orgMiscWeight: 0,
      orgMiscOks: 0,
      orgBookWeight: 0,
      orgBookOks: 0,
      orgFurn: 0,
      orgOLI: 0,
      orgLocationId: null,
    },
  ],
  destLocations: [
    {
      destConsignee: null,
      destETA: null,
      destSoftWeight: 0,
      destSoftOks: 0,
      destMiscWeight: 0,
      destMiscOks: 0,
      destBookWeight: 0,
      destBookOks: 0,
      destFurn: 0,
      destOLI: 0,
      destLocationId: null,
    },
  ],
};

export const REQUEST_TYPES = {
  INBOUND: { value: 'I', desc: 'Inbound' },
  OUTBOUND: { value: 'O', desc: 'Outbound' },
  TRANSFER: { value: 'T', desc: 'Transfer' },
};
